import { JSONSerializer } from './JSONSerializer'
import { getStorageItem, setStorageItem } from './storage.utils'

/**
 * @typedef {object} StorageSerializer
 *
 * @property {(value: *) => string | null} serialize
 *
 * @property {(item: string | null) => * | null} deserialize
 */

export class AsyncStorage {
  /**
   * Browser storage
   * @type {Storage}
   */
  #storage

  /**
   * Serializer
   * @type {StorageSerializer}
   */
  #serializer

  /**
   *
   * @param {Storage} storage
   * @param {StorageSerializer} [serializer = JSONSerializer]
   */
  constructor(storage, serializer = JSONSerializer) {
    this.#storage = storage
    this.#serializer = serializer
  }

  /**
   * @template {*} TValue
   *
   * @param {string} key
   * @param {TValue} defaultValue
   *
   * @returns {Promise<TValue>}
   */
  getItem(key, defaultValue) {
    return new Promise(resolve => {
      const value = getStorageItem(key, null, this.#storage)

      resolve(this.#serializer.deserialize(value) ?? defaultValue)
    })
  }

  /**
   * @template {*} TValue
   *
   * @param {string} key
   * @param {TValue} value
   *
   * @returns {Promise<TValue>}
   */
  setItem(key, value) {
    return new Promise(resolve => {
      setStorageItem(key, this.#serializer.serialize(value), this.#storage)

      resolve(value)
    })
  }
}
